import React from 'react'

type TimelineTargetContextType = {
  targetID: string | null
  setTargetID: React.Dispatch<React.SetStateAction<string | null>>
}

const TimelineTargetContext =
  React.createContext<TimelineTargetContextType>(null)

const TimelineTargetProvider = ({ children }) => {
  const [targetID, setTargetID] = React.useState<string | null>(null)

  return (
    <TimelineTargetContext.Provider value={{ targetID, setTargetID }}>
      {children}
    </TimelineTargetContext.Provider>
  )
}

export default TimelineTargetProvider

export const useTimelineTarget = () => React.useContext(TimelineTargetContext)
